export function splitMultipleEmails(emailAddresses: string): string[] {
  // Split by both ',' and ' '
  const emails = emailAddresses.split(',').map(email => email.trim());
  return [].concat(...emails.map(email => email.replace(/\s\s+/g, ' ').split(' ')));
}
